// extracted by mini-css-extract-plugin
export var divider = "_p8-0";
export var systemMessage = "_p8-1";
export var systemMessageWrapper = "_p8-2";